import { connect } from 'react-redux'
import { get } from 'lodash'
import BillingAccount from './BillingAccount'
import { getBillingAccount } from 'features/Billing/Billing.actions'
import { submit } from 'redux-form'

const stateToProps = ({ form, billing }, { routeParams: { ban } }) => ({
  billingAccounts: billing.billingAccounts,
  billingAccount: billing.billingAccounts.find(account => account.ban === ban) || {},
  ban,
  savePending: get(form, 'billingAccountForm.submitting', false),
})

const dispatchToProps = {
  getBillingAccount,
  submit,
}

export default connect(stateToProps, dispatchToProps)(BillingAccount)



// WEBPACK FOOTER //
// ./src/pages/BillingAccount/BillingAccount.container.js